<template>
  <div class="card">
    <div class="card-body">
      <b-button variant="primary" to="/questionAdd">
        <i class="bx bx-plus font-size-14 align-middle me-2">新建</i>
      </b-button>
    </div>
    <div class="col-lg-12 list-header pad-header-bg clearfix">
      <div class="header-item-fix">
        <b-button variant="outline-secondary" @click="reset()" size="sm">
          <i class="bx bx-revision font-size-16 align-middle"></i>重置
        </b-button>
      </div>
      <div class="header-item-fix">
        <b-button variant="primary" @click="search()" size="sm">
          <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>搜索
        </b-button>
      </div>
      <div class="header-item-fix">
        <b-form-input size="sm" type="text" placeholder="请输入搜索内容" v-model="listParam.contentKeyword" style="width:240px;"></b-form-input>
      </div>
      <div class="header-item-fix">
        <el-select v-model="listParam.status" @change="resetPage" clearable placeholder="筛选状态" style="width:150px;">
          <el-option v-for="item in statusList" :key="item.value" :label="item.text" :value="item.value"></el-option>
        </el-select>
      </div>
    </div>
    <div class="card-body">
      <div class="col-lg-12">
        <div class="table-responsive">
          <table class="table project-list-table table-nowrap table-centered table-borderless align-middle table-hover">
            <thead>
              <tr>
                <th scope="col" style="width: 70px;" class="font-size-16">
                  <b-form-checkbox @change="checkedAll" v-model="indeterminate" checked plain></b-form-checkbox>
                </th>
                <th scope="col">ID</th>
                <th scope="col" class="w-300">问答标题</th>
                <th scope="col">封面</th>
                <th scope="col">优惠券已发放</th>
                <th scope="col">状态</th>
                <th scope="col">阅读</th>
                <th scope="col">创建日期</th>
                <th scope="col">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="list in listData" :key="list.id">
                <td class="font-size-16">
                  <b-form-checkbox v-model="choiceListIds" :value="list.id" checked plain></b-form-checkbox>
                </td>
                <td>{{list.id}}</td>
                <td class="w-300 white-inherit">{{list.title}}</td>
                <td>
                  <img v-if="list.image" class="avatar-sm" :src="`${list.image}`" alt />
                  <img v-if="!list.image" class="avatar-sm" src="../../../assets/images/image-null.jpg" alt="">
                </td>
                <td>{{list.receiveRewardNum}}</td>
                <td>
                  <template v-if="list.status === 1">
                    <p class="mb-2 text-truncate" @click="online(list.id)"><i class="mdi mdi-circle text-danger me-1"></i>下架</p>
                  </template>
                  <template v-else>
                    <p class="mb-2 text-truncate" @click="offline(list.id)"><i class="mdi mdi-circle text-success me-1"></i>上架</p>
                  </template>
                </td>
                <td>{{list.viewNum}}</td>
                <td>{{list.createAt}}</td>
                <td>
                  <button type="button" class="btn-sm btn btn-primary m-r-10" @click="edit(list.id)">编辑</button>
                  <button type="button" class="btn-sm btn btn-warning m-r-10" @click="joinList(list)">参与列表</button>
                  <button type="button" class="btn-sm btn btn-primary" @click="toHistory(list)">领取列表</button>

                  <!-- <ul class="list-inline font-size-22 contact-links mb-0">
                    <li class="list-inline-item px-2" @click="edit(list.id)">
                      <a v-b-tooltip.hover title="编辑">
                        <i class="bx bx-edit"></i>
                      </a>
                    </li>
                    <li class="list-inline-item px-2" @click="joinList(list)">
                      <a v-b-tooltip.hover title="参与列表">
                        <i class="bx bx-line-chart"></i>
                      </a>
                    </li> -->
                    <!-- <li class="list-inline-item px-2" @click="data(list)">
                        <a v-b-tooltip.hover title="数据统计">
                          <i class="bx bx-line-chart"></i>
                        </a>
                      </li> -->
                  <!-- </ul> -->
                </td>
              </tr>
              <tr v-if="!listData.length">
                <td colspan='8' style="text-align:center !important;">暂无数据</td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination :isBatch="true" :batchs="[]" ref="page" @pageCallback="pageCallback" v-show="listData.length"></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import pagination from "@/components/pagination/pagination.vue"; //置顶稿件
import question from "../../../server/api/question";

export default {
  components: {
    pagination,
  },
  mounted() {
    let user = JSON.parse(this.cookies.getCookie("user"));
    console.log(user);
    this.listParam.merchantId = user.userId;
    this.getDatas();
  },
  data() {
    return {
      indeterminate: false,
      choiceListIds: [],
      allListIds: [],
      listData: [],
      statusList: [
        { text: "全部", value: "" },
        { text: "上架", value: "2" },
        { text: "下架", value: "1" },
      ],
      listParam: {
        contentKeyword: null,
        status: "",
        page: 1,
        pageSize: 20,
        order: null,
        sortBy: null,
        merchantId: 0,
      },
      tagList: [],
      batchs: [
        { text: "批量操作", value: "0" },
        { text: "上架", value: "1" },
        { text: "下架", value: "2" },
      ],
    };
  },
  watch: {
    choiceListIds: function () {
      if (
        this.choiceListIds.length == this.allListIds.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
  },
  methods: {
    // 列表全选
    checkedAll() {
      if (this.indeterminate) {
        this.choiceListIds = this.allListIds;
      } else {
        this.choiceListIds = [];
      }
    },
    search() {
      this.getDatas();
    },
    resetPage() {
      this.listParam.page = 1;
      this.getDatas();
    },
    toHistory(item){
      if(item.couponId){
        this.$router.push({
          name: 'couponsReceive',
          query: { id: item.couponId }
        });
      } else {
        if(item.redPacket && item.redPacket.id){
          this.$router.push({
            name: 'redPacketHistory',
            query: { redPacketId: item.redPacket.id }
          });
        }
      }
    },

    reset() {
      let user = JSON.parse(this.cookies.getCookie("user"));
      console.log(userId);
      userId = user.userId;
      this.listParam = {
        contentKeyword: "",
        status: "",
        page: 1,
        pageSize: 20,
        order: null,
        sortBy: null,
        merchantId: userId,
      };
      this.search();
    },
    getDatas() {
      let params = this.utils.getQuery(this.listParam);
      console.log(params);
      question.merchantList(params).then((resp) => {
        console.log(resp);
        if (resp.data) {
          if (resp.data.items) {
            let ids = [];
            resp.data.items.map((item) => {
              ids.push(item.id);
            });
            this.choiceListIds = [];
            this.allListIds = ids; //当前列表全部id
            this.listData = resp.data.items;
            let pages = {
              page: resp.data.page, //第几页
              pageSize: resp.data.pageSize, //每页多少条
              total: resp.data.total, //全部有多少条数据
              totalPages: resp.data.totalPages, //全部有几页
            };
            this.$nextTick(() => {
  if (this.$refs.page) {
    this.$refs.page.setPages(pages);
  }
});
          }
        }
      });
    },
    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      if (obj.code === "batch") {
        //处理批量操作
        if (obj.batch == 1) {
          if (this.choiceListIds.length) {
            this.online(this.choiceListIds.join(","));
          } else {
            Vue.swal("请选择要上架的内容");
            return;
          }
        } else if (obj.batch == 2) {
          if (this.choiceListIds.length) {
            this.offline(this.choiceListIds.join(","));
          } else {
            Vue.swal("请选择要下架的内容");
            return;
          }
        }
      }
    },
    online(id) {
      Swal.fire({
        title: "确定上线问答?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.isConfirmed) {
          question
            .show({ ids: id })
            .then((resp) => {
              console.log(resp);
              if (resp) {
                Vue.swal({
                  icon: resp.code == 0 ? "success" : "error",
                  title: resp.msg,
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.search();
              }
            })
            .catch((ex) => {
              Vue.swal({
                icon: "error",
                title: ex.msg,
                showConfirmButton: false,
                timer: 1500,
              });
            });
        }
      });
    },
    offline(id) {
      question.contentOperationInfo({id, type: 'qa'}).then((msg) => {
        Swal.fire({
          title: msg != '' ? `
            <span>
              本内容已被添加到<br/>${msg} 中，确定隐藏/移除
            </span>
          ` : '确定移除问答?',
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#f46a6a",
          cancelButtonColor: "#74788d",
          confirmButtonText: "确认",
          cancelButtonText: "取消",
        }).then((result) => {
          if (result.isConfirmed) {
            question
              .hidden({ ids: id })
              .then((resp) => {
                console.log(resp);
                if (resp) {
                  Vue.swal({
                    icon: resp.code == 0 ? "success" : "error",
                    title: resp.msg,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.search();
                }
              })
              .catch((ex) => {
                Vue.swal({
                  icon: "error",
                  title: ex.msg,
                  showConfirmButton: false,
                  timer: 1500,
                });
              });
          }
        });
      }).catch((err) => {
        Vue.swal(`校验是否删除失败${err}`)
      })
    },
    edit(id) {
      this.$router.push({
        name: "questionAdd",
        query: {
          id: id,
        },
      });
    },
    joinList(item) {
      this.$router.push({
        name: "questionAttends",
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>

